import { Route, Routes } from 'react-router-dom'
import { Login } from './auth/Login'
import { RequireAuth } from './auth/RequireAuth'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { NotFound } from './pages/NotFound'
import { GlowList } from './pages/GlowList'
import { GlowCreate } from './pages/GlowCreate'
import { GlowDetail } from './pages/GlowDetail'
import { Billing } from './pages/Billing'
import { AccountUsage } from './pages/AccountUsage'

// App declares the route tree. The authenticated subtree lives under
// RequireAuth + Layout; /login is public.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/glows" element={<GlowList />} />
        <Route path="/glows/new" element={<GlowCreate />} />
        <Route path="/glows/:id" element={<GlowDetail />} />
        <Route path="/usage" element={<AccountUsage />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
